// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#loading[data-v-43882d5c] {\n\tmargin: 0 auto;\n\ttext-align: center;\n}\n[v-cloak][data-v-43882d5c] {\n\tdisplay: none;\n}\n\n\t\n", ""]);
// Exports
module.exports = exports;
